import { isNetworkClass } from "@utils/durableCache/createDurableCache";

export const isAccessNetworkError = isNetworkClass;
